import React from "react";
import about2Img from "../../../assets/Images/about/nutralike-about.jpeg";

const DirectorWord_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">

      {/* Background Image */}
      <img
        src={about2Img}
        alt="Director's Word"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">

        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Director's Word
        </h1>

        {/* Description */}
        <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-xl leading-relaxed">
          A message from our director on vision, values, and what drives us forward.
        </p>

      </div>
    </section>
  );
};

export default DirectorWord_Banner;
